import { call, put, takeEvery } from "redux-saga/effects"

import {
  DELETE_ADMIN_USER_BANNER_MESSAGES,
  DELETE_BANNER_MESSAGES,
  GET_ADMIN_USER_BANNER_MESSAGES,
  GET_BANNER_MESSAGES,
} from "./actionTypes"

import {
  getBannerMessagesSuccess,
  getBannerMessagesError,
  deleteBannerMessagesError,
  deleteBannerMessagesSuccess,
  getAdminUserBannerMessagesSuccess,
  getAdminUserBannerMessagesError,
  deleteAdminUserBannerMessagesSuccess,
  deleteAdminUserBannerMessagesError
} from "./actions"

import { genericDeleteRequest, genericGetRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetBannerMessages() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_notifications`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getBannerMessagesSuccess(response))
  } catch (error) {
    yield put(getBannerMessagesError(error))
  }
}

function* onGetAdminUserBannerMessages() {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_notification`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminUserBannerMessagesSuccess(response))
  } catch (error) {
    yield put(getAdminUserBannerMessagesError(error))
  }
}


function* onDeleteAdminUserBannerMessages(action) {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_notifications/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token
        }
      }
    )
    yield put(deleteAdminUserBannerMessagesSuccess(response))
  } catch (error) {
    yield put(deleteAdminUserBannerMessagesError(error))
  }
}

function* onDeleteBannerMessages(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_notifications/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id
        }
      }
    )
    yield put(deleteBannerMessagesSuccess(response))
  } catch (error) {
    yield put(deleteBannerMessagesError(error))
  }
}

function* BannerMessagesSaga() {
  yield takeEvery(GET_BANNER_MESSAGES, onGetBannerMessages)
  yield takeEvery(DELETE_BANNER_MESSAGES, onDeleteBannerMessages)
  yield takeEvery(GET_ADMIN_USER_BANNER_MESSAGES, onGetAdminUserBannerMessages)
  yield takeEvery(DELETE_ADMIN_USER_BANNER_MESSAGES, onDeleteAdminUserBannerMessages)
}

export default BannerMessagesSaga;
